import { HttpClient } from "@/service/httpClient";
import Keycloak from "@dsb-norge/vue-keycloak-js";

import { SocketService } from "@/service/socket";

export const keycloakOptions = ({ router, url, realm, clientId, onReady }) => ({
  init: {
    onLoad: "login-required",
    checkLoginIframe: false,
  },
  config: {
    url,
    realm,
    clientId,
  },
  onReady: async (keycloak) => {
    // console.log("> on ready: ", keycloak);
    const { authenticated, token } = keycloak || {};

    // # 토큰이 없을 경우 로드안함
    if (!authenticated) return;

    HttpClient.setToken(token);

    let socketService = {};
    try {
      socketService = new SocketService({ token });
      await socketService.asyncConnect();
    } catch (e) {
      console.error("Error connecting to socket :>> ", e);
    }

    if (typeof onReady === "function") {
      onReady({ socketService });
    }
  },
  onInitError: (error, err) => {
    // console.log("> init error");
    throw new Error(error.message || err.error);
  },
  onAuthRefreshSuccess: (keycloak) => {
    HttpClient.setToken(keycloak.token);
  },
  onAuthRefreshError: () => {
    HttpClient.removeToken();
    router.app.$keycloak.logoutFn();
  },
});

export default Keycloak;
